<template>
  <div id="app" data-app="false">
    <router-view/>
    <LoadingGlobal/>
  </div>
</template>

<script>
import LoadingGlobal from '@/components/LoadingGlobal.vue';

export default {
  name: 'App',
  components: {
    LoadingGlobal,
  },
  created() {
    sessionStorage.clear();
    if (localStorage.theme == 'dark') {
      document.body.className = 'body-inverted';
    }
  },
  beforeDestroy() {
    localStorage.clear();
    sessionStorage.clear();
  },
};
</script>

<style>
  .body-inverted {
    background-color: #a2a2a2 !important;
  }
</style>
